import { ILoadCardFooter } from './ILoadCardFooter';
import './load-card-footer.scss';

export default function LoadCardFooter(props: Readonly<ILoadCardFooter>) {
    const {
        iconButtons,
        mainButtons,
        hiddenIconButtons,
        isPool = false,
        hasRate = true,
    } = props;

    return (
        <div className={`card-loads-footer ${isPool ? 'pool-footer' : ''}`}>
            {iconButtons && !hiddenIconButtons && (
                <div
                    className={`card-loads-footer__icons ${isPool ? 'pool-icons' : ''}`}
                    data-testid="card-loads-footer__icons"
                >
                    {iconButtons}
                </div>
            )}
            {mainButtons && (
                <div
                    className="card-loads-footer__buttons"
                    style={{
                        gap: hiddenIconButtons ? '0' : '16px',
                        visibility: hasRate ? 'visible' : 'hidden',
                    }}
                    data-testid="card-loads-footer__buttons"
                >
                    {mainButtons}
                </div>
            )}
        </div>
    );
}
